import React from "react";
import { NavLink } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import fb from "../MODELS/FirebaseModule";
import TestIcon from "../IMG/Test.png";
import MessageIcon from "../IMG/Message.png";
import UploadIcon from "../IMG/Upload.png";
import AnswerIcon from "../IMG/Answer.png";
import HelpIcon from "../IMG/Help.png";
import FeedbackIcon from "../IMG/Feedback.png";
import GraphIcon from "../IMG/Graph.png";

const auth = fb.auth();
const MessageButtonStyle = {
  backgroundColor: "#4775E7",
};
const UploadButtonStyle = {
  backgroundColor: "#4EA5DC",
};
const AnswerButtonStyle = {
  backgroundColor: "#8971E1",
};
const TestButtonStyle = {
  backgroundColor: "#D54773",
};
const HelpButtonStyle = {
  backgroundColor: "#E32D91",
};
const FeedbackButtonStyle = {
  backgroundColor: "#C830CC",
};
const StatsButtonStyle = {
  backgroundColor: "#4EA5DC",
};

class Menu extends React.Component {
  render() {
    return (
      <>
        <div className="sidebar">
          <ListGroup>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink
                to="/Message"
                className="linkItem"
                style={MessageButtonStyle}
              >
                <img src={MessageIcon} alt="Message"></img>
                <div>MESSAGE</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink
                to="/Upload"
                className="linkItem"
                style={UploadButtonStyle}
              >
                <img src={UploadIcon} alt="Upload"></img>
                <div>UPLOAD</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink
                to="/Answer"
                className="linkItem"
                style={AnswerButtonStyle}
              >
                <img src={AnswerIcon} alt="Answer"></img>
                <div>ANSWER</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink to="/Test" className="linkItem" style={TestButtonStyle}>
                <img src={TestIcon} alt="Test"></img>
                <div>TEST</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink to="/Help" className="linkItem" style={HelpButtonStyle}>
                <img src={HelpIcon} alt="Help"></img>
                <div>HELP</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink
                to="/Feedback"
                className="linkItem"
                style={FeedbackButtonStyle}
              >
                <img src={FeedbackIcon} alt="Feedback"></img>
                <div>FEEDBACK</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <NavLink
                to="/Stats"
                className="linkItem"
                style={StatsButtonStyle}
              >
                <img src={GraphIcon} alt="Stats"></img>
                <div>STATS</div>
              </NavLink>
            </ListGroup.Item>
            <ListGroup.Item variant="dark" className="menuItem">
              <SignOut />
            </ListGroup.Item>
          </ListGroup>
        </div>
      </>
    );
  }
}
function SignOut() {
  return (
    auth.currentUser && (
      <button className="sign-in" onClick={() => auth.signOut()}>
        SIGN OUT
      </button>
    )
  );
}

export default Menu;
